import React from 'react';
import HeroBgAnimation from '../HeroBgAnimation';
import {
  HeroContainer,
  HeroBg,
  HeroLeftContainer,
  HeroRightContainer,
  HeroInnerContainer,
  TextLoop,
  Title,
  Span,
  SubTitle,
  ResumeButton,
  SecondaryButton
} from './HeroStyle';
import Typewriter from 'typewriter-effect';
import { Bio } from '../../data/constants';
import ComputersCanvas from '../canvas/Computers';

const HeroSection = () => {
  return (
    <div id="home">
      <HeroContainer>
        <HeroBg>
          <HeroBgAnimation />
        </HeroBg>
        <HeroInnerContainer>
          <HeroLeftContainer id="Left">
            <Title>
              Hi, I am <br /> {Bio.name}
            </Title>
            <TextLoop>
              I am a
              <Span>
                <Typewriter
                  options={{
                    strings: Bio.roles,
                    autoStart: true,
                    loop: true,
                  }}
                />
              </Span>
            </TextLoop>
            <SubTitle>
              {Bio.headline}
            </SubTitle>
            <div style={{
              display: 'flex',
              gap: '16px',
              flexWrap: 'wrap',
              width: '100%',
              alignItems: 'center'
            }}>
              <ResumeButton
                href={Bio.resume}
                target="_blank"
                rel="noopener noreferrer"
              >
                Check Resume
              </ResumeButton>
              <SecondaryButton
                href={Bio.github}
                target="_blank"
                rel="noopener noreferrer"
              >
                GitHub Profile
              </SecondaryButton>
            </div>
          </HeroLeftContainer>

          <HeroRightContainer id="Right">
            <ComputersCanvas />
          </HeroRightContainer>
        </HeroInnerContainer>
      </HeroContainer>
    </div>
  );
};

export default HeroSection;
